document.querySelectorAll('[data-mayam-product]').forEach((root) => {
  const variants = JSON.parse(root.querySelector('[data-mayam-variants]').textContent);
  const selectors = [...root.querySelectorAll('[data-mayam-option]')];
  const input = root.querySelector('[data-mayam-variant]');
  const button = root.querySelector('[data-mayam-add]');
  const price = root.querySelector('[data-mayam-price]');
  const compare = root.querySelector('[data-mayam-compare]');
  const comparePrice = root.querySelector('[data-mayam-compare-price]');
  const discount = root.querySelector('[data-mayam-discount]');
  const whatsapp = root.querySelector('[data-mayam-whatsapp]');
  const colorHelp = root.querySelector('[data-mayam-color-help]');
  const browseColor = root.querySelector('[data-mayam-browse-color]');
  const variantColor = selectors.find((select) => ['color', 'colour', 'couleur'].includes(select.dataset.optionName));
  const swatches = [...root.querySelectorAll('[data-mayam-swatch]')];
  const colorLabel = root.querySelector('[data-mayam-color-label]');
  const gallery = root.querySelector('.my-gallery');
  const galleryItems = [...root.querySelectorAll('[data-mayam-gallery-item]')];
  const colorOrders = {"10385452466459":["off-white","Beige","Gray","Black","Navy Blue","Almond Cream","Teracotta","Dark Olive Green"],"10364274442523":["White","Black","Olive Green"],"10533299061019":["White","Black","Green","Gray","Navy","Mustard","Burgundy","Dark Olive Green","Olive Green"],"10533679890715":["White","Olive Green","Burgundy","Black","Navy","Gray"]};
  const productId = root.querySelector('input[name="product-id"]')?.value;
  const colorOrder = colorOrders[productId];
  const scopedGallery = !!colorOrder;
  const photoNote = root.querySelector('[data-mayam-photo-note]');
  const fr = true;
  const money = (cents) => `${new Intl.NumberFormat(document.documentElement.lang || 'en', { maximumFractionDigits: 2 }).format(cents / 100)} MAD`;
  let lastColor;
  function update() {
    const chosenColor = (browseColor || variantColor)?.value || '';
    if (colorLabel && variantColor) colorLabel.textContent = variantColor.selectedOptions[0]?.textContent.trim() || chosenColor;
    swatches.forEach((swatch, index) => {
      if (scopedGallery) {
        const fills = {'white':'#f4f2ec','off-white':'#e9e4d8','almond cream':'#d8c5a3','beige':'#c7ad7a','black':'#252423','gray':'#8e9091','navy':'#293449','navy blue':'#293449','green':'#359050','mustard':'#aa7b38','burgundy':'#722639','dark olive green':'#42482e','olive green':'#77804b','teracotta':'#ad5135'};
        const fill = fills[(colorOrder[index] || '').toLowerCase()];
        if (fill) swatch.style.setProperty('--my-swatch', fill);
      }
      swatch.setAttribute('aria-pressed', String(swatch.dataset.value === chosenColor));
      const translated = [...(variantColor?.options || [])].find((option) => option.value === swatch.dataset.value)?.textContent.trim();
      if (translated) { swatch.setAttribute('aria-label', translated); swatch.title = translated; }
    });
    const galleryColor = scopedGallery && variantColor ? colorOrder[variantColor.selectedIndex] || chosenColor : chosenColor;
    const matchingImages = galleryItems.filter((item) => item.dataset.mayamColor.toLowerCase() === galleryColor.toLowerCase());
    if (root.dataset.productTitle.toLowerCase().includes('chemise')) {
      matchingImages.sort((a, b) => Number(b.querySelector('img').alt.toLowerCase().includes('shirt')) - Number(a.querySelector('img').alt.toLowerCase().includes('shirt')));
    }
    if (photoNote && scopedGallery) photoNote.textContent = 'Photo indisponible pour cette couleur.';
    if (photoNote) photoNote.hidden = !chosenColor || matchingImages.length > 0 || !galleryItems.some((item) => item.dataset.mayamColor);
    if (chosenColor !== lastColor && gallery) {
      const orderedImages = [...matchingImages, ...galleryItems.filter((item) => !matchingImages.includes(item))];
      orderedImages.forEach((item, index) => {
        item.hidden = scopedGallery && !!chosenColor && !matchingImages.includes(item);
        if (scopedGallery) item.style.setProperty('display', item.hidden ? 'none' : 'block', 'important');
        item.classList.toggle('my-gallery__item--lead', index === 0);
        gallery.appendChild(item);
      });
      gallery.scrollLeft = 0;
      if (lastColor !== undefined) {
        const bounds = gallery.getBoundingClientRect();
        if (bounds.top < 0 || bounds.top >= window.innerHeight) {
          (photoNote && !photoNote.hidden ? photoNote : gallery).scrollIntoView({ block: 'start', behavior: 'instant' });
        }
      }
    }
    lastColor = chosenColor;
    const selected = selectors.map((select) => select.value);
    const variant = variants.find((v) => v.options.every((value, index) => value === selected[index]));
    if (!variant) { input.value = ''; root.querySelector('[data-mayam-sticky-buy]').disabled = true; button.disabled = true; button.textContent = fr ? 'Indisponible' : 'Unavailable'; return; }
    input.value = variant.id;
    root.querySelectorAll('[data-mayam-cod-host] input[name="id"]').forEach(el => { el.value = variant.id; });
    root.querySelectorAll('[data-mayam-cod-host] input[name="product-id"]').forEach(el => { el.value = root.querySelector('.my-buy-form input[name="product-id"]').value; });
    root.querySelectorAll('[data-mayam-cod-host] input[name="quantity"]').forEach(el => { el.value = 1; });
    input.dispatchEvent(new Event('change', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant } }));
    price.textContent = money(variant.price);
    root.querySelector('[data-mayam-sticky-price]').textContent = money(variant.price);
    const stickyButton = root.querySelector('[data-mayam-sticky-buy]');
    stickyButton.disabled = !variant.available;
    stickyButton.textContent = variant.available ? 'Acheter maintenant' : 'Épuisé';
    if (compare) {
      compare.hidden = !variant.compare_at_price || variant.compare_at_price <= variant.price;
      if (!compare.hidden && comparePrice) comparePrice.textContent = money(variant.compare_at_price);
    }
    if (discount) {
      discount.hidden = !variant.compare_at_price || variant.compare_at_price <= variant.price;
      if (!discount.hidden) discount.textContent = `−${Math.floor((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price)}%`;
    }
    const viewingUnavailableColor = !!browseColor && browseColor.value !== 'White';
    button.disabled = !variant.available || viewingUnavailableColor;
    stickyButton.disabled = button.disabled;
    button.textContent = viewingUnavailableColor ? (fr ? 'Couleur non disponible en ligne' : 'Color unavailable online') : variant.available ? (fr ? 'Acheter maintenant' : 'Acheter maintenant') : (fr ? 'Épuisé' : 'Sold out');
    if (whatsapp) {
      const title = whatsapp.dataset.productTitle;
      const options = [...(browseColor ? [fr ? browseColor.selectedOptions[0].textContent.trim() : browseColor.value] : []), ...selectors.map((select) => fr ? select.selectedOptions[0].textContent.trim() : select.value)].join(' / ');
      const message = fr
        ? `Bonjour MAYAM, j'ai une question concernant ${title} (${options}) : ${window.location.href}`
        : `Hello MAYAM, I have a question about the color and size of ${title} (${options}): ${window.location.href}`;
      whatsapp.href = `https://wa.me/212666294350?text=${encodeURIComponent(message)}`;
      if (colorHelp) {
        colorHelp.hidden = !viewingUnavailableColor;
        colorHelp.href = whatsapp.href;
      }
    }
  }
  selectors.forEach((select) => select.addEventListener('change', update));
  swatches.forEach((swatch) => swatch.addEventListener('click', () => {
    if (!variantColor) return;
    variantColor.value = swatch.dataset.value;
    variantColor.dispatchEvent(new Event('change', { bubbles: true }));
  }));
  if (browseColor) browseColor.addEventListener('change', update);
  update();
});

